import React from "react";

export const LocalTransportRuleDetailContext = React.createContext(null);

export const useLocalTransportRuleDetailContext = () => {
  const context = React.useContext(LocalTransportRuleDetailContext);
  if (!context)
    throw new Error("LocalTransportRule Detail Context not provided!");
  return context;
};
